import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSyncClockwise = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16 5.33325V1.33325L21.3333 6.66658L16 11.9999V7.99992C11.5866 7.99992 7.99996 11.5866 7.99996 15.9999C7.99996 17.3466 8.33329 18.6266 8.93329 19.7333L6.98663 21.6799C5.94663 20.0399 5.33329 18.0933 5.33329 15.9999C5.33329 10.1066 10.1066 5.33325 16 5.33325ZM16 23.9999C20.4133 23.9999 24 20.4132 24 15.9999C24 14.6533 23.6666 13.3733 23.0666 12.2666L25.0133 10.3199C26.0533 11.9599 26.6666 13.9066 26.6666 15.9999C26.6666 21.8933 21.8933 26.6666 16 26.6666V30.6666L10.6666 25.3333L16 19.9999V23.9999Z",
		fill: "#BFD2DB"
	})
});
export default SvgSyncClockwise;
